/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Which rule a question broke, when its field is checked by more than one rule and the field alone cannot say what to fix — in a form\'s violations as code, in an import report as rule. MAX_POINTS_NOT_POSITIVE, MAX_POINTS_PRECISION (more than one decimal place), MAX_POINTS_TOO_HIGH (10 000 or more); CORRECT_OPTION_MISSING — a test question with no option marked correct, a single choice included; SINGLE_CHOICE_MANY_CORRECT — a single choice with more than one, which makes it a multiple choice; ORDER_PLACE_MISSING — an option without a place in the correct order; ORDER_PLACES_INVALID — places that do not run from 1 to the number of options, each once; ANSWER_POINTS_PRECISION, ANSWER_POINTS_RANGE (0 to 100); TOPICS_TO_PICK_MISSING, TOPICS_TO_PICK_RANGE (1 to the number of topics); SCALE_MAX_MISSING, SCALE_MAX_RANGE (1 to 10); BODY_MISSING, BODY_TOO_LONG (over 2000 characters). Values may be added; without one the field says it all.
 * @export
 * @enum {string}
 */

export const QuestionRuleDto = {
    MaxPointsNotPositive: 'MAX_POINTS_NOT_POSITIVE',
    MaxPointsPrecision: 'MAX_POINTS_PRECISION',
    MaxPointsTooHigh: 'MAX_POINTS_TOO_HIGH',
    CorrectOptionMissing: 'CORRECT_OPTION_MISSING',
    SingleChoiceManyCorrect: 'SINGLE_CHOICE_MANY_CORRECT',
    OrderPlaceMissing: 'ORDER_PLACE_MISSING',
    OrderPlacesInvalid: 'ORDER_PLACES_INVALID',
    AnswerPointsPrecision: 'ANSWER_POINTS_PRECISION',
    AnswerPointsRange: 'ANSWER_POINTS_RANGE',
    TopicsToPickMissing: 'TOPICS_TO_PICK_MISSING',
    TopicsToPickRange: 'TOPICS_TO_PICK_RANGE',
    ScaleMaxMissing: 'SCALE_MAX_MISSING',
    ScaleMaxRange: 'SCALE_MAX_RANGE',
    BodyMissing: 'BODY_MISSING',
    BodyTooLong: 'BODY_TOO_LONG'
} as const;

export type QuestionRuleDto = typeof QuestionRuleDto[keyof typeof QuestionRuleDto];



